define([
	"dojo/_base/declare",
	"csi/_base/underscore",
	"csi/def/View",
	"csi/util"
], function(declare, _, View, util) {

	/*
			<View Id="QuestionSlicer" xsi:type="Slicer" SlicerStore="X">
				<FilterClassifier Key="OprLevel2" Op="EQ" Value="thisNode()" />
				
				<RowClassifier Key="OprLevel3" Total="1" CollapseTotal="1" />
				<RowClassifier Key="OprLevel4" />
				
				<ColumnClassifier Key="Quarter" Compare="1" />
				<ColumnClassifier Key="QuestionSection" Total="1" />
	
				<Metric Key="PointsScored" />
				<Metric Key="Score" />
			</View>
	*/

	return declare(View, {
		// String: id of slicer store (required)
		//slicerStore: "",

		// Object[]: array of filters to limit data in view
		//slicerFilters: null,

		// Object[]: array of metrics to use in value area (required)
		//slicerMetrics: null,

		// Object[]: array of classifiers to use in column area (required)
		//slicerColumns: null,

		// Object[]: array of classifiers to use in row area (required)
		//slicerRows: null,

		constructor: function(/*XMLNode*/xn) {
			if (!xn) return;

			this.slicerStore = util.getProperty(xn, "SlicerStore");
			this.slicerMetrics = util.getProperties(xn, "Metric", "Key");

			this.slicerFilters = util.getDefs(xn, "FilterClassifier", function(x) {
				return {
					key: util.getProperty(x, "Key"),
					op: util.getProperty(x, "Op"),
					value: util.getProperty(x, "Value")
				};
			}, true);

			this.slicerColumns = util.getDefs(xn, "ColumnClassifier", function(x) {
				return {
					key: util.getProperty(x, "Key"),
					total: util.getBooleanProperty(x, "Total") == "1",
					collapse: util.getBooleanProperty(x, "CollapseTotal") == "1",
					compare: util.getBooleanProperty(x, "Compare") == "1"
				};
			}, true);

			this.slicerRows = util.getDefs(xn, "RowClassifier", function(x) {
				return {
					key: util.getProperty(x, "Key"),
					total: util.getBooleanProperty(x, "Total") == "1",
					collapse: util.getBooleanProperty(x, "CollapseTotal") == "1"
				};
			}, true);
		},

		shouldResolveRootClass: function() {
			// summary: view will resolve only attributes in slicer store
			return false;
		}
	});
});